import ShowAlert from 'Utils/ShowAlert'
import globalsService from 'Services/globalsService'
import loadScript from 'Utils/loadScript'

const load = (callback) =>
  loadScript(
    'https://checkout.razorpay.com/v1/checkout.js',
    'razorpayScript',
    callback
  )

export default {
  makePayment(inputOptions, callbackFn, is_ylurn_payment) {
    load(() => {
      const options = {
        key: is_ylurn_payment ? globalsService.getConstant('YLURN_RAZORPAY_KEY') : globalsService.getConstant('RAZORPAY_KEY'),
        amount: '', // will be left empty for order id based payments
        description: '',
        name: '',
        image: '', // no logo on website payment handler modal
        prefill: {
          name: '',
          email: '',
        },
        handler(response) {
          callbackFn(response)
        },
        ...inputOptions,
      }
      if (typeof Razorpay === 'undefined') {
        ShowAlert(
          'An error occurred while initiating the payment. Please reload the page and try again.',
          'error'
        )
        return
      }
      const rzpObject = new Razorpay(options)
      rzpObject.open()
      /*
        external: {
           wallets: ['paytm'],
           handler: function(data) {
             // write code on how to handle the external wallet here, based on the param 'data' https://ylurn.com/payment/handler/paytm/
            }
          },
        */
    })
  },
}
